import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    id: "section-bottom",
    class: _normalizeClass(['section-bottom',_ctx.route.path==='/index'?'isIndex':''])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headerText.bottomFields, (text) => {
      return (_openBlock(), _createElementBlock("div", { key: text }, _toDisplayString(text), 1))
    }), 128))
  ], 2))
}